import * as React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import ImpersonatorNotice from '../components/ImpersonatorNotice';
import MainSidebar from '../components/navigation/MainSidebar';
import SyncingNotice from '../components/SyncingNotice';
import { useFinancialAccounts } from '../hooks/queries/useFinancialAccounts';
import { PATHS } from '../paths';

const HomeScene = () => {
  const navigate = useNavigate();
  const { financialAccounts, loading: financialAccountsLoading } = useFinancialAccounts();

  React.useEffect(() => {
    if (!financialAccountsLoading && financialAccounts.length === 0) {
      void navigate(PATHS.ONBOARDING);
    }
  }, [financialAccountsLoading, financialAccounts, navigate]);

  return (
    <div className="flex h-full w-full">
      <MainSidebar />
      <div className="flex min-w-0 flex-1 flex-col items-center">
        <div className="flex w-full max-w-[1600px] flex-col">
          <div className="m-3 mb-0 flex flex-col gap-2">
            <ImpersonatorNotice />
            <SyncingNotice />
          </div>
          <div className="flex min-w-0 flex-1 overflow-hidden">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeScene;
